
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="Full Screen Loading" fileName="fullscreen.md" />
        <demo-block>
        <div><p>1、通过<code>fullscreen</code>参数，指定 Loading 全屏展示<br>2、通过<code>lock</code>参数，指定禁止鼠标滚动</p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        &lt;button class=&quot;button-demo&quot; @click=&quot;show()&quot;&gt;Open&lt;/button&gt;
    &lt;/div&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data() {
            return {
                loadingInstance: null,
            };
        },
        methods: {
            show() {
                this.loadingInstance.show();

                setTimeout(() =&gt; {
                    this.loadingInstance.close();
                }, 2000);
            },
        },
        mounted() {
            this.loadingInstance = this.$veLoading({
                fullscreen: true,
                name: &quot;bounce&quot;,
                lock: true,
            });
        },
        destroyed() {
            this.loadingInstance.destroy();
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('button',{staticClass:"button-demo",on:{"click":function($event){return _vm.show()}}},[_vm._v("Open")])])]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                loadingInstance: null,
            };
        },
        methods: {
            show() {
                this.loadingInstance.show();

                setTimeout(() => {
                    this.loadingInstance.close();
                }, 2000);
            },
        },
        mounted() {
            this.loadingInstance = this.$veLoading({
                fullscreen: true,
                name: "bounce",
                lock: true,
            });
        },
        destroyed() {
            this.loadingInstance.destroy();
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  